import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LOGO_URL } from "@/lib/constants";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Signed in.");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-canvas" data-testid="login-page">
      <div className="hidden md:block md:w-1/2 relative overflow-hidden bg-ink">
        <img
          src="/images/property/king-room-wide.jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/40 to-ink" />
        <div className="absolute bottom-12 left-12 right-12 text-canvas">
          <p className="font-mono-label text-canvas/60 mb-3">Westbridge Inn & Suites</p>
          <p className="font-display text-5xl leading-tight">
            Back-of-house.<br /><span className="italic">Welcome in.</span>
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8 md:p-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-8" data-testid="login-form">
          <div className="flex items-center gap-4 mb-8">
            <img src={LOGO_URL} alt="" className="w-12 h-12 rounded-sm" />
            <div>
              <p className="font-display text-2xl text-ink">Admin sign-in</p>
              <p className="font-mono-label text-ink-muted">For Westbridge staff only</p>
            </div>
          </div>

          <label className="block">
            <span className="font-mono-label text-ink-muted">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-rule-strong py-3 focus:border-ember outline-none transition-colors"
              data-testid="login-email"
            />
          </label>

          <label className="block">
            <span className="font-mono-label text-ink-muted">Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border-b border-rule-strong py-3 focus:border-ember outline-none transition-colors"
              data-testid="login-password"
            />
          </label>

          <button type="submit" disabled={busy} className="btn-ember w-full justify-center disabled:opacity-60" data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>

          <p className="font-mono-label text-ink-muted text-center">
            Need access? Contact the property manager.
          </p>
        </form>
      </div>
    </div>
  );
}
